import { TonConnectUIPlugin, useTonConnectUI } from '@townsquarelabs/ui-vue'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(TonConnectUIPlugin, {
    manifestUrl:
      'https://staging.tma.hhaa.io/tonconnect-manifest.json',
    actionsConfiguration: { twaReturnUrl: 'https://t.me/hamrahtmg_bot/start' },
  })

  return {
    provide: { useTonConnectUI },
  }
})
